module.exports = __webpack_public_path__ + "img/2024shnh-5.082774b4.jpg";